module.exports = __webpack_public_path__ + "static/img/scanning.125ea86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scanning.png
// module id = Utux
// module chunks = 0